export const pageConfig = {
  shinkawa_1: {
    pref_list: [
      '北海道'
    ],
    name: '新川'
  },
  tsutsumikawa_1: {
    pref_list: [
      '青森県'
    ],
    name: '堤川'
  },
  nanakitagawa: {
    pref_list: [
      '宮城県'
    ],
    name: '七北田川'
  },
  nikkougawa_1: {
    pref_list: [
      '山形県'
    ],
    name: '日向川'
  },
  utagawa: {
    pref_list: [
      '宮城県',
      '福島県'
    ],
    name: '宇多川'
  },
  niidagawa_2: {
    pref_list: [
      '福島県'
    ],
    name: '新田川'
  },
  natsuigawa: {
    pref_list: [
      '福島県'
    ],
    name: '夏井川'
  },
  sakawagawa: {
    pref_list: [
      '神奈川県',
      '静岡県'
    ],
    name: '酒匂川'
  },
  minamikawa: {
    pref_list: [
      '福井県'
    ],
    name: '南川'
  },
  shounokawa: {
    pref_list: [
      '福井県'
    ],
    name: '笙の川'
  },
  ootagawa_3: {
    pref_list: [
      '静岡県'
    ],
    name: '太田川'
  },
  miyakodagawa: {
    pref_list: [
      '静岡県'
    ],
    name: '都田川'
  },
  sakaigawa_2: {
    pref_list: [
      '愛知県'
    ],
    name: '境川'
  },
  tenpakugawa_1: {
    pref_list: [
      '愛知県'
    ],
    name: '天白川'
  },
  nikkougawa_2: {
    pref_list: [
      '愛知県'
    ],
    name: '日光川'
  },
  ootsugawa_3: {
    pref_list: [
      '大阪府'
    ],
    name: '大津川'
  },
  mukogawa: {
    pref_list: [
      '兵庫県'
    ],
    name: '武庫川'
  },
  ichikawa: {
    pref_list: [
      '兵庫県'
    ],
    name: '市川'
  },
  chikusagawa: {
    pref_list: [
      '兵庫県'
    ],
    name: '千種川'
  },
  kozagawa: {
    pref_list: [
      '和歌山県'
    ],
    name: '古座川'
  },
  hidakagawa: {
    pref_list: [
      '和歌山県'
    ],
    name: '日高川'
  },
  aritagawa: {
    pref_list: [
      '和歌山県'
    ],
    name: '有田川'
  },
  yuragawa_3: {
    pref_list: [
      '鳥取県'
    ],
    name: '由良川'
  },
  masudagawa: {
    pref_list: [
      '島根県'
    ],
    name: '益田川'
  },
  sufugawa: {
    pref_list: [
      '島根県'
    ],
    name: '周布川'
  },
  sasagasegawa: {
    pref_list: [
      '岡山県'
    ],
    name: '笹ヶ瀬川'
  },
  nutagawa: {
    pref_list: [
      '広島県'
    ],
    name: '沼田川'
  },
  kurosegawa: {
    pref_list: [
      '広島県'
    ],
    name: '黒瀬川'
  },
  nishikigawa: {
    pref_list: [
      '山口県'
    ],
    name: '錦川'
  },
  shimadagawa: {
    pref_list: [
      '山口県'
    ],
    name: '島田川'
  },
  fushinogawa: {
    pref_list: [
      '山口県'
    ],
    name: '椹野川'
  },
  kotougawa: {
    pref_list: [
      '山口県'
    ],
    name: '厚東川'
  },
  katsuuragawa: {
    pref_list: [
      '徳島県'
    ],
    name: '勝浦川'
  },
  koutougawa: {
    pref_list: [
      '香川県'
    ],
    name: '香東川'
  },
  mikasagawa: {
    pref_list: [
      '福岡県'
    ],
    name: '御笠川'
  },
  yakkangawa: {
    pref_list: [
      '大分県'
    ],
    name: '駅館川'
  },
  hirotogawa: {
    pref_list: [
      '宮崎県'
    ],
    name: '広渡川'
  },
  manosegawa: {
    pref_list: [
      '鹿児島県'
    ],
    name: '万之瀬川'
  },
  teshiogawa: {
    pref_list: [
      '北海道'
    ],
    name: '天塩川'
  },
  rumoigawa: {
    pref_list: [
      '北海道'
    ],
    name: '留萌川'
  },
  ishikarigawa: {
    pref_list: [
      '北海道'
    ],
    name: '石狩川'
  },
  shiribetsugawa: {
    pref_list: [
      '北海道'
    ],
    name: '尻別川'
  },
  shiribeshitoshibetsugawa: {
    pref_list: [
      '北海道'
    ],
    name: '後志利別川'
  },
  mukawa: {
    pref_list: [
      '北海道'
    ],
    name: '鵡川'
  },
  sarugawa: {
    pref_list: [
      '北海道'
    ],
    name: '沙流川'
  },
  tokachigawa: {
    pref_list: [
      '北海道'
    ],
    name: '十勝川'
  },
  kushirokawa: {
    pref_list: [
      '北海道'
    ],
    name: '釧路川'
  },
  abashirigawa: {
    pref_list: [
      '北海道'
    ],
    name: '網走川'
  },
  tokorogawa: {
    pref_list: [
      '北海道'
    ],
    name: '常呂川'
  },
  yuubetsugawa: {
    pref_list: [
      '北海道'
    ],
    name: '湧別川'
  },
  shokotsugawa: {
    pref_list: [
      '北海道'
    ],
    name: '渚滑川'
  },
  abukumagawa: {
    pref_list: [
      '宮城県',
      '福島県'
    ],
    name: '阿武隈川'
  },
  natorigawa: {
    pref_list: [
      '宮城県'
    ],
    name: '名取川'
  },
  narusegawa: {
    pref_list: [
      '宮城県'
    ],
    name: '鳴瀬川'
  },
  kitakamigawa: {
    pref_list: [
      '岩手県',
      '宮城県'
    ],
    name: '北上川'
  },
  mabechigawa: {
    pref_list: [
      '青森県',
      '岩手県'
    ],
    name: '馬淵川'
  },
  takasegawa_1: {
    pref_list: [
      '青森県'
    ],
    name: '高瀬川'
  },
  iwakigawa: {
    pref_list: [
      '青森県'
    ],
    name: '岩木川'
  },
  yoneshirogawa: {
    pref_list: [
      '岩手県',
      '秋田県'
    ],
    name: '米代川'
  },
  omonogawa: {
    pref_list: [
      '秋田県'
    ],
    name: '雄物川'
  },
  koyoshigawa: {
    pref_list: [
      '秋田県'
    ],
    name: '子吉川'
  },
  mogamigawa: {
    pref_list: [
      '山形県'
    ],
    name: '最上川'
  },
  akagawa_2: {
    pref_list: [
      '山形県'
    ],
    name: '赤川'
  },
  kujigawa_2: {
    pref_list: [
      '福島県',
      '茨城県'
    ],
    name: '久慈川'
  },
  nakagawa_1: {
    pref_list: [
      '茨城県',
      '栃木県'
    ],
    name: '那珂川'
  },
  tonegawa: {
    pref_list: [
      '茨城県',
      '栃木県',
      '群馬県',
      '埼玉県',
      '千葉県',
      '東京都'
    ],
    name: '利根川'
  },
  arakawa_1: {
    pref_list: [
      '埼玉県',
      '東京都'
    ],
    name: '荒川'
  },
  tamagawa_2: {
    pref_list: [
      '東京都',
      '神奈川県',
      '山梨県'
    ],
    name: '多摩川'
  },
  tsurumigawa: {
    pref_list: [
      '東京都',
      '神奈川県'
    ],
    name: '鶴見川'
  },
  sagamigawa: {
    pref_list: [
      '神奈川県',
      '山梨県'
    ],
    name: '相模川'
  },
  fujikawa: {
    pref_list: [
      '山梨県',
      '長野県',
      '静岡県'
    ],
    name: '富士川'
  },
  arakawa_2: {
    pref_list: [
      '山形県',
      '新潟県'
    ],
    name: '荒川'
  },
  aganogawa: {
    pref_list: [
      '福島県',
      '新潟県'
    ],
    name: '阿賀野川'
  },
  shinanogawa: {
    pref_list: [
      '新潟県',
      '長野県'
    ],
    name: '信濃川'
  },
  sekikawa_1: {
    pref_list: [
      '新潟県',
      '長野県'
    ],
    name: '関川'
  },
  himekawa_2: {
    pref_list: [
      '新潟県',
      '長野県'
    ],
    name: '姫川'
  },
  kurobegawa: {
    pref_list: [
      '富山県'
    ],
    name: '黒部川'
  },
  jouganjigawa: {
    pref_list: [
      '富山県'
    ],
    name: '常願寺川'
  },
  jinzuugawa: {
    pref_list: [
      '富山県',
      '岐阜県'
    ],
    name: '神通川'
  },
  shougawa: {
    pref_list: [
      '富山県',
      '岐阜県'
    ],
    name: '庄川'
  },
  oyabegawa: {
    pref_list: [
      '富山県'
    ],
    name: '小矢部川'
  },
  tedorigawa: {
    pref_list: [
      '石川県'
    ],
    name: '手取川'
  },
  kakehashigawa: {
    pref_list: [
      '石川県'
    ],
    name: '梯川'
  },
  kanogawa: {
    pref_list: [
      '静岡県'
    ],
    name: '狩野川'
  },
  abekawa: {
    pref_list: [
      '静岡県'
    ],
    name: '安倍川'
  },
  ooigawa_1: {
    pref_list: [
      '静岡県'
    ],
    name: '大井川'
  },
  kikukawa: {
    pref_list: [
      '静岡県'
    ],
    name: '菊川'
  },
  tenryuugawa: {
    pref_list: [
      '長野県',
      '静岡県',
      '愛知県'
    ],
    name: '天竜川'
  },
  toyokawa: {
    pref_list: [
      '愛知県'
    ],
    name: '豊川'
  },
  yahagigawa: {
    pref_list: [
      '長野県',
      '岐阜県',
      '愛知県'
    ],
    name: '矢作川'
  },
  shounaigawa: {
    pref_list: [
      '岐阜県',
      '愛知県'
    ],
    name: '庄内川'
  },
  kisogawa: {
    pref_list: [
      '長野県',
      '岐阜県',
      '愛知県',
      '三重県'
    ],
    name: '木曽川'
  },
  suzukagawa: {
    pref_list: [
      '三重県'
    ],
    name: '鈴鹿川'
  },
  kumozugawa: {
    pref_list: [
      '三重県'
    ],
    name: '雲出川'
  },
  kushidagawa: {
    pref_list: [
      '三重県'
    ],
    name: '櫛田川'
  },
  miyagawa_1: {
    pref_list: [
      '三重県'
    ],
    name: '宮川'
  },
  shinguugawa: {
    pref_list: [
      '三重県',
      '奈良県',
      '和歌山県'
    ],
    name: '新宮川'
  },
  kinokawa_2: {
    pref_list: [
      '奈良県',
      '和歌山県'
    ],
    name: '紀の川'
  },
  yamatogawa: {
    pref_list: [
      '大阪府',
      '奈良県'
    ],
    name: '大和川'
  },
  yodogawa: {
    pref_list: [
      '三重県',
      '滋賀県',
      '京都府',
      '大阪府',
      '兵庫県',
      '奈良県'
    ],
    name: '淀川'
  },
  kakogawa: {
    pref_list: [
      '兵庫県'
    ],
    name: '加古川'
  },
  ibogawa: {
    pref_list: [
      '兵庫県'
    ],
    name: '揖保川'
  },
  kuzuryuugawa: {
    pref_list: [
      '福井県'
    ],
    name: '九頭竜川'
  },
  kitagawa_2: {
    pref_list: [
      '福井県',
      '滋賀県'
    ],
    name: '北川'
  },
  yuragawa_1: {
    pref_list: [
      '京都府'
    ],
    name: '由良川'
  },
  maruyamagawa_2: {
    pref_list: [
      '兵庫県'
    ],
    name: '円山川'
  },
  chiyokawa: {
    pref_list: [
      '鳥取県'
    ],
    name: '千代川'
  },
  tenjinkawa: {
    pref_list: [
      '鳥取県'
    ],
    name: '天神川'
  },
  hinogawa: {
    pref_list: [
      '鳥取県'
    ],
    name: '日野川'
  },
  hiikawa: {
    pref_list: [
      '鳥取県',
      '島根県'
    ],
    name: '斐伊川'
  },
  gounokawa: {
    pref_list: [
      '島根県',
      '広島県'
    ],
    name: '江の川'
  },
  takatsugawa: {
    pref_list: [
      '島根県'
    ],
    name: '高津川'
  },
  sabagawa: {
    pref_list: [
      '山口県'
    ],
    name: '佐波川'
  },
  ozegawa: {
    pref_list: [
      '広島県',
      '山口県'
    ],
    name: '小瀬川'
  },
  ootagawa_5: {
    pref_list: [
      '広島県'
    ],
    name: '太田川'
  },
  ashidagawa: {
    pref_list: [
      '広島県'
    ],
    name: '芦田川'
  },
  takahashigawa_2: {
    pref_list: [
      '岡山県',
      '広島県'
    ],
    name: '高梁川'
  },
  asahikawa: {
    pref_list: [
      '岡山県'
    ],
    name: '旭川'
  },
  yoshiigawa: {
    pref_list: [
      '岡山県'
    ],
    name: '吉井川'
  },
  shigenobugawa: {
    pref_list: [
      '愛媛県'
    ],
    name: '重信川'
  },
  hijikawa: {
    pref_list: [
      '愛媛県'
    ],
    name: '肱川'
  },
  dogawa: {
    pref_list: [
      '愛媛県',
      '高知県'
    ],
    name: '渡川'
  },
  niyodogawa: {
    pref_list: [
      '愛媛県',
      '高知県'
    ],
    name: '仁淀川'
  },
  monobegawa: {
    pref_list: [
      '高知県'
    ],
    name: '物部川'
  },
  nakagawa_4: {
    pref_list: [
      '徳島県'
    ],
    name: '那賀川'
  },
  yoshinogawa: {
    pref_list: [
      '徳島県',
      '香川県',
      '愛媛県',
      '高知県'
    ],
    name: '吉野川'
  },
  dokigawa: {
    pref_list: [
      '香川県'
    ],
    name: '土器川'
  },
  ongagawa: {
    pref_list: [
      '福岡県'
    ],
    name: '遠賀川'
  },
  matsuuragawa: {
    pref_list: [
      '佐賀県'
    ],
    name: '松浦川'
  },
  honmeigawa: {
    pref_list: [
      '長崎県'
    ],
    name: '本明川'
  },
  rokkakugawa: {
    pref_list: [
      '佐賀県'
    ],
    name: '六角川'
  },
  kasegawa: {
    pref_list: [
      '佐賀県'
    ],
    name: '嘉瀬川'
  },
  chikugogawa: {
    pref_list: [
      '福岡県',
      '佐賀県',
      '熊本県',
      '大分県'
    ],
    name: '筑後川'
  },
  yabegawa_1: {
    pref_list: [
      '福岡県'
    ],
    name: '矢部川'
  },
  kikuchigawa: {
    pref_list: [
      '熊本県'
    ],
    name: '菊池川'
  },
  shirakawa: {
    pref_list: [
      '熊本県'
    ],
    name: '白川'
  },
  midorikawa_2: {
    pref_list: [
      '熊本県'
    ],
    name: '緑川'
  },
  kumagawa: {
    pref_list: [
      '熊本県'
    ],
    name: '球磨川'
  },
  sendaigawa: {
    pref_list: [
      '熊本県',
      '宮崎県',
      '鹿児島県'
    ],
    name: '川内川'
  },
  kimotsukigawa: {
    pref_list: [
      '鹿児島県'
    ],
    name: '肝属川'
  },
  ooyodogawa: {
    pref_list: [
      '宮崎県',
      '鹿児島県'
    ],
    name: '大淀川'
  },
  omarugawa: {
    pref_list: [
      '宮崎県'
    ],
    name: '小丸川'
  },
  gokasegawa: {
    pref_list: [
      '熊本県',
      '宮崎県'
    ],
    name: '五ヶ瀬川'
  },
  banjougawa: {
    pref_list: [
      '大分県'
    ],
    name: '番匠川'
  },
  oonokawa_3: {
    pref_list: [
      '熊本県',
      '大分県',
      '宮崎県'
    ],
    name: '大野川'
  },
  ooitagawa: {
    pref_list: [
      '大分県'
    ],
    name: '大分川'
  },
  yamagunigawa: {
    pref_list: [
      '福岡県',
      '大分県'
    ],
    name: '山国川'
  }
}
